import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';
import { ROLES } from '@constants/roles.constants';

export enum EWidgetTypeEntrance {
  Token = 'deeplink',
  Email = 'email',
}

@Injectable({
  providedIn: 'root',
})
export class WidgetAuthorizedGuard {
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const routeKeys = { ...route.params, ...route.queryParams };
    const isHomeownerAccess = !!localStorage.getItem('homeowner_access');

    if (
      Object.prototype.hasOwnProperty.call(routeKeys, EWidgetTypeEntrance.Token) &&
      !!routeKeys?.deeplink
    ) {
      return this.router.createUrlTree([`deeplink/${routeKeys?.deeplink}`]);
    }
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)) {
      return this.router.createUrlTree(['home']);
    }
    if (
      Object.prototype.hasOwnProperty.call(routeKeys, EWidgetTypeEntrance.Email) &&
      !!routeKeys?.email
    ) {
      const email = routeKeys?.email && routeKeys?.email !== 'null' ? routeKeys?.email : '';
      localStorage.setItem(LOCAL_STORAGE_KEYS.ROLE, ROLES.TENANT);
      localStorage.setItem(LOCAL_STORAGE_KEYS.TENANT_EMAIL, email);
      return this.router.createUrlTree([isHomeownerAccess ? '' : 'auth/sign-in']);
    }
    return this.router.createUrlTree(['']);
  }
}
